export const faqData = [
  {
    id: 1,
    question: "What is the maximum loan amount i can get?",
    answer:
      "You can get up to 20,00,000 based on your income and credit score.",
  },
  {
    id: 2,
    question: " What is the minimum credit score required for a personal loan?",
    answer:
      "Most lenders prefer a credit score above 660, but eligibility can vary by lender. Check your personal loan eligibility with Minemi to find out where you stand.",
  },
  {
    id: 3,
    question: "Does checking loan eligibility impact my credit score?",
    answer:
      "No, checking your eligibility through Minemi does not impact your credit score since it's a soft inquiry.",
    // answerList: [
    //   {
    //     heading: " Loan Amount: ",
    //     info: "Higher amounts lead to higher EMIs.",
    //   },
    //   {
    //     heading: " Interest Rate:",
    //     info: "Lower rates reduce your EMI and total repayment.",
    //   },
    //   {
    //     heading: "Tenure:  ",
    //     info: " Longer tenures lower EMIs but increase total interest.",
    //   },
    // ],
  },
  {
    id: 4,
    question: " How much personal loan can I get? ",
    answer:
      "Your personal loan amount depends on your income, current financial obligations, and credit score. Use Minemi's eligibility checker to see how much you qualify for without affecting your credit score.",
  },
  {
    id: 5,
    question: "Can I apply for a personal loan if I have other ongoing loans?",
    answer:
      "Yes, but your eligibility is influenced by your FOIR (Fixed Obligation to Income Ratio). Minemi can help you understand how your existing loans affect your personal loan eligibility.",
  },
  {
    id: 6,
    question: " How quickly can I get my personal loan?",
    answer:
      "Personal loans are typically disbursed within a few days, depending on the lender’s verification process. Use Minemi to streamline the process and get personalized loan offers.",
  },
  // {
  //   id: 7,
  //   question: "What happens if I miss an EMI payment?",
  //   answer:
  //     "Some credit cards allow balance transfers from personal loans or other credit cards. However, this depends on the card issuer’s policies.",
  // },
  // {
  //   id: 8,
  //   question: "Is a personal loan better than a credit card?",
  //   answer:
  //     "Focus on timely repayments of the new balance to take full advantage of the lower interest rate. Avoid accumulating new debt on the old account to prevent further financial strain.",
  // },
];
